import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [MatSlideToggleModule],
  exports: [MatSlideToggleModule]
})
export class TiimeSlideToggleModule {}
